import { Role } from '@guiker/permissions'

import { BookingActions } from '../booking-actions'
import { BookingRoleNames } from '../role-names'

export const SpectatorRole: Role = {
  name: BookingRoleNames.SPECTATOR,
  permissions: [{ action: BookingActions.ViewTenancy }],
}
